import { render, staticRenderFns } from "./MypageContractDetailsPane.vue?vue&type=template&id=0835b6ca&scoped=true"
import script from "./MypageContractDetailsPane.vue?vue&type=script&lang=ts"
export * from "./MypageContractDetailsPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageContractDetailsPane.vue?vue&type=style&index=0&id=0835b6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835b6ca",
  null
  
)

export default component.exports